import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const MerchantCreateAddService = ({
  open,
  close,
  setLoading,
  getAddtionalServiceList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [isSRPOff, setIsSRPOff] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const handleSaveToService = (values) => {
    // console.log("values", values);
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to additional service successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getAddtionalServiceList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Additional Service"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-services"
        initialValues={{
          service_desc: "",
        }}
        onFinish={handleSaveToService}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="service"
            label="Service Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set product name" size="large" />
          </Form.Item>

          <Form.Item name="service_desc" label="Service Description">
            <Input placeholder="Set product description" size="large" />
          </Form.Item>

          <Form.Item
            name="service_type"
            label="Service Type"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              onChange={(e) => setSelectedType(e)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={"consumable"}>Consumable</Select.Option>
              <Select.Option value={"duration"}>Duration</Select.Option>
              <Select.Option value={"one-time"}>One Time</Select.Option>
            </Select>
          </Form.Item>

          {selectedType === "duration" && (
            <Form.Item
              name="service_duration"
              label="Service Duration"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                onChange={(e) => console.log("EVENT", e)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"hour"}>Hour</Select.Option>
                <Select.Option value={"day"}>Day</Select.Option>
                <Select.Option value={"month"}>Month</Select.Option>
              </Select>
            </Form.Item>
          )}

          <Form.Item
            name="srp"
            label="SRP"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>

          <Form.Item
            name="is_srp_off"
            label="Allow SRP off"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => setIsSRPOff(e)}
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item>

          {parseInt(isSRPOff) === 1 && (
            <Form.Item
              name="before_srp"
              label="Before SRP"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>
          )}

          <Form.Item
            name="service_charge_exempted"
            label="Service Charge Exempted"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              // onChange={(e) => setIsSRPOff(e)}
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item>

          {/* <Form.Item
            name="is_fast_moving"
            label="Set as hot"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item> */}

          {/* <Form.Item
            name="is_best_seller"
            label="Set as Best Seller"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item> */}
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantCreateAddService;
